/**
 * Map ExtraHorizon role names onto the dashboard's built-in permission roles.
 */

import { Role, ROLES } from "lib/biot/roles/types";

/**
 * Convert an ExtraHorizon staff-enlistment role name to a built-in role.
 *
 * Role names come from `staffEnlistments[].roles[].name` and are hyphenated
 * (e.g. "dashboard-admin"). Unknown or missing names fall back to the
 * read-only Patient Viewer role.
 *
 * @param roleName - role name from a staff enlistment
 * @returns the matching built-in Role (and its permissions)
 */
export const exhRoleNameToRole = (roleName?: string): Role => {
  switch (roleName) {
    case "dashboard-admin":
      return ROLES.DASHBOARD_ADMIN;
    case "patient-manager":
      return ROLES.PATIENT_MANAGER;
    case "patient-viewer":
      return ROLES.PATIENT_VIEWER;
    case "restricted-user":
      return ROLES.RESTRICTED_USER;
    case "user-manager":
      return ROLES.USER_MANAGER;
    default:
      return ROLES.PATIENT_VIEWER;
  }
};
